// extracted by mini-css-extract-plugin
module.exports = {"line":"BarChart_line__2ldo0","centerContent":"BarChart_centerContent__ysXLB"};